import 'phaser'
import { IBlueprint } from '../blueprints/blueprints'
import { IAsteroid } from '../entities/asteroids'
import { ICargo } from '../entities/cargoes'
import { ICargoType } from '../entities/cargoesData'
import { IEntity } from '../entities/entitiesUtils'
import { entitiesUtils } from '../entities/entitiesUtils-sidecar'

import { assert } from '../lib/assert-sidecar'
import { l } from '../lib/imports'
import { IMachine } from '../machines/machines'
import { createId } from '../main/common'
import { IMonster } from '../monsters/monsters'
import { jobsList } from './jobsList-sidecar'

export type IJobType =
  | 'error'
  | 'fill-water'
  | 'melt-ice'
  | 'unstack'
  | 'stack'
  // | 'move-to-stack'
  | 'mine'
  | 'deconstruct-hull'
  | 'construct-hull'
  | 'drink'
  | 'eat'
  | 'harvest'
  | 'build'
  | 'take-off-suit'
  | 'put-away-carried-cargo'
  | 'idle'
  | 'debuild'
  | 'sleep'
  | 'fill-battery'
  | 'fill-with'
  | 'move-to'

export type ITaskType =
  | 'error'
  | 'custom'
  | 'fetch-cargo'
  | 'deliver-cargo'
  | 'unstack-cargo'
  | 'stack-cargo'
  | 'consume-cargo'
  | 'put-on-suit'
  | 'take-off-suit'
  | 'exit-ship'
  | 'enter-ship'
  | 'move-to'
  | 'mine'
  | 'place-in-empty-space'
  | 'deconstruct-hull'
  | 'construct-hull'
  | 'go-to-machine'
  | 'harvest'
  | 'build'
  | 'debuild'
  | 'put-away'
  | 'drink'
  | 'fill'

type JobRunner = (job: IJob) => void
const registeredJobs: { [key in IJobType]?: JobRunner } = {}
export const registerJob = (type: IJobType, action: JobRunner) => {
  assert.nil(registeredJobs[type], 'already registered job', type)
  registeredJobs[type] = action
}
export const getRegisteredJob = (type: IJobType): JobRunner => {
  let a = registeredJobs[type]
  assert.notNil(a, 'missing job type', type)
  return a
}

type TaskRunner = (job: IJob, task: ITask) => void
const registeredTasks: { [key in ITaskType]?: TaskRunner } = {}
export const registerTask = (type: ITaskType, action: TaskRunner) => {
  assert.nil(registeredTasks[type], 'already registered task', type)
  registeredTasks[type] = action
}
export const getRegisteredTask = (type: ITaskType): TaskRunner => {
  let a = registeredTasks[type]
  assert.notNil(a, 'missing task type', type)
  return a
}

jobsList.registerAll()

export interface ITask extends IEntity {
  type: ITaskType
  cargoType: ICargoType
  cargoFilter: ((cargo: ICargo) => boolean) | null
  targetCargo: ICargo | null
  isComplete: boolean
  isFailed: boolean
  isInsideShip: boolean
  i: number
  j: number
  allowFromStack: boolean
  counter: number
  machineFilter: (m: IMachine) => boolean

  action: (task: ITask) => void
  subtasks: ITask[]

  allowNextTo: boolean
  progress: number

  onFail: null | (() => boolean)
}

export interface IJob extends IEntity {
  type: IJobType
  team: number
  reservedBy: IMonster | null
  onlyFor: IMonster | null
  machine: IMachine | null
  stack: IMachine | null
  asteroid: IAsteroid | null
  blueprint: IBlueprint | null
  targetCargo: ICargo | null
  // targetCargoType: ICargoType | null

  cargoType: ICargoType | null
  cargoFilter: ((cargo: ICargo) => boolean) | null
  findPathId: number
  isComplete: boolean
  isFailed: boolean
  tasks: ITask[]
  invalidCargoes: ICargo[]

  stage: number

  priority: number
  ticks: number
  i: number
  j: number
  isInShip: boolean
  onFill: null | ((job: IJob) => boolean)
}

const trueFilter = () => true
const falseFilter = () => false
const noop = () => {}

const objs: IJob[] = []
export function getAll() {
  return objs
}
export function findById(id: number) {
  return entitiesUtils.findById(id, objs)
}

export function _createTask(
  i: number,
  j: number,
  type: ITaskType,
  alterations: Partial<ITask>,
) {
  let id = createId()

  let task: ITask = Object.assign(
    {},
    {
      eType: 'job',
      type: type,
      id,
      isDead: false,
      cargoType: 'error',
      targetCargo: null,
      cargoFilter: null,
      i,
      j,
      isComplete: false,
      isFailed: false,
      allowFromStack: true,
      action: noop,
      machineFilter: falseFilter,
      subtasks: [],
      isInsideShip: true,
      onFail: null,
      counter: 0,
      allowNextTo: false,
      progress: 0,
    },
    alterations,
  )
  return task
}

export function create(type: IJobType, team: number = 1): IJob {
  let id = createId()

  let obj: IJob = {
    eType: 'job',
    team,
    type,
    id,
    isDead: false,
    reservedBy: null,
    onlyFor: null,
    blueprint: null,
    machine: null,
    stack: null,
    asteroid: null,
    targetCargo: null,
    cargoType: null,
    cargoFilter: null,
    findPathId: 0,
    isComplete: false,
    isFailed: false,
    invalidCargoes: [],
    tasks: [],
    priority: 0,
    ticks: 0,
    onFill: null,
    i: -1,
    j: -1,
    isInShip: false,
    stage: 0,
  }

  objs.push(obj)

  return obj
}

export function killAll() {
  objs.forEach((c) => {
    kill(c)
  })
}
export function kill(obj: IJob) {
  obj.isDead = true
}

export function updateAll() {
  objs.forEach((c) => {
    update(c)
  })
  entitiesUtils.removeDead(objs, (c) => {})
}
function update(obj: IJob) {
  if (obj.isComplete || obj.isFailed) {
    kill(obj)
    // TODO: save completed, failed somewhere for a while (debug)
  }
}

export function report() {
  console.log('jobs report')
  l.forEach(objs, (c) => {
    console.log(c.type)
    console.log(c)
  })
}

const jobFilter = (monster: IMonster) => (c: IJob) =>
  c.reservedBy === null &&
  !c.isDead &&
  !c.isComplete &&
  !c.isFailed &&
  (c.onlyFor == null || c.onlyFor === monster) &&
  c.team == monster.team

export function getTopJob(monster: IMonster) {
  let j = l.find(objs, jobFilter(monster))
  if (j) {
    assignJob(j, monster)
  }
}

export function getRandomJob(monster: IMonster) {
  let jobs = l.filter(objs, jobFilter(monster))
  let j = l.sample(jobs)
  if (j) {
    assignJob(j, monster)
  }
}

export function assignJob(job: IJob | null, monster: IMonster) {
  if (monster.currentJob) {
    unassignJob(monster)
  }

  if (!job) {
    return
  }

  if (job.reservedBy) {
    unassignJob(job.reservedBy)
  }
  monster.currentJob = job
  job.reservedBy = monster
}

export function unassignJob(monster: IMonster) {
  if (monster.currentJob) {
    if (monster.currentJob.reservedBy === monster) {
      monster.currentJob.reservedBy = null
    }
    monster.currentJob = null
  }
}
